module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [(_vm.showTitle) ? _c('span', [(['Aktivitas', 'AHV-Vorstand', 'HBV-Vorstand'].includes(_vm.vorstand)) ? _c('v-card-title', [_vm._v("Chargen " + _vm._s(_vm.vorstand))]) : _c('v-card-title', [_vm._v(_vm._s(_vm.vorstand))])], 1) : _vm._e(), _vm._v(" "), (['Aktivitas', 'AHV-Vorstand', 'HBV-Vorstand', 'Ripuarentage'].includes(_vm.vorstand)) ? _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "nav": "",
      "dense": ""
    }
  }, _vm._l((_vm.chargen), function(item, key, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          (_vm.showKontakt = true) && (_vm.bbr = item)
        }
      }
    }, [_c('v-list-item-content', {
      staticClass: "pl-2"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-normal"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('v-list-item-subtitle', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.vorname) + " " + _vm._s(item.nachname))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.handy))])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "text-center"
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "href": "mailto:" + item.chargenmail
      }
    }, [_c('v-icon', [_vm._v("mail")])], 1)], 1)], 1)
  }), 1) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "nav": "",
      "dense": ""
    }
  }, _vm._l((_vm.chargen), function(item, key, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "link": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "pl-2"
    }, [_c('v-list-item-title', {
      staticClass: "font-weight-normal"
    }, [_vm._v(_vm._s(item.titel))]), _vm._v(" "), _vm._l((item.berechtigt), function(item2) {
      return _c('v-list-item-subtitle', {
        key: _vm.bbr,
        staticClass: "font-weight-bold"
      }, [_c('v-chip', {
        staticClass: "grey lighten-4",
        attrs: {
          "small": "",
          "label": ""
        },
        on: {
          "click": function($event) {
            return _vm.showBbr(item2)
          }
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$filters.user(item2, _vm.bbrbbr)) + "\n          ")])], 1)
    }), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(item.handy))])], 2)], 1)
  }), 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4568fe3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/chargen.vue
// module id = 768
// module chunks = 15